// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/thunderstorm-types-and-severity.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/thunderstorm-types-and-severity/thunderstorm-types-and-severity.js';

mount([g0]);
